import request from '@/utils/request';

/* 상품 조회 */
export function getEstGgoodsList(data) {
	return request({
		url: '/estimate/ggoods/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 담은 상품 가져오기 */
export function getEstCartList(data) {
	return request({
		url: '/estimate/cart/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 담은 상품 삭제하기 - 1개씩 */
export function delEstGoods(data) {
	return request({
		url: '/estimate/cart/del',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 담은 상품 삭제하기 - 선택 */
export function delEstGoodsAll(data) {
	return request({
		url: '/estimate/cart/delstd',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 견적서 리스트 가져오기 */
export function getEstList(data) {
	return request({
		url: '/estimate/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 견적서 정보 가져오기 */
export function getEstInfo(data) {
	return request({
		url: '/estimate/info',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 견적서 저장 */
export function addEstHistory(data) {
	return request({
		url: '/estimate/add',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 임시저장 저장 */
export function tmpAdd(data) {
	return request({
		url: '/estimate/tmpAdd',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 견적서 이메일 발송 */
export function sendEstimate(data) {
	return request({
		url: '/estimate/sendEstimate',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 임시저장 견적서 삭제 */
export function delTempEstimate(data) {
	return request({
		url: '/estimate/del',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 등급코드 리스트 가져오기 */
export function getLevelCodeList(data) {
	return request({
		url: '/user/getDiscountInfo',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/* 담은상품 리스트 업데이트 */
export function updateEstimateGoodsInfo(data) {
	return request({
		url: '/estimate/updateEstimateGoodsInfo',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
